<template>
  <Block v-if="monthlyPerformance?.target" :title="title" emoji="🎯" class="mb-4">
    <template #subtitle>
      <p class="text-sm text-gray-600">
        <span class="font-bold">{{ monthlyPerformance?.salesCurrent ?? 0 }}</span>
        {{ t("sales_on") }}
        <span class="font-bold">{{ monthlyPerformance?.target ?? 0 }}</span>
        {{ t("expected") }}
      </p>
    </template>
    <template v-if="monthlyPerformance?.projection != null" #actions>
      <span class="text-sm text-gray-600 whitespace-nowrap hidden sm:inline">
        {{ t("projection_label") }}
        <span class="font-bold">{{ t("projection_value", { count: monthlyPerformance.projection }) }}</span>
      </span>
    </template>
    <div class="px-6 pb-4">
      <p v-if="monthlyPerformance?.projection != null" class="text-sm text-gray-600 mb-2 sm:hidden">
        {{ t("projection_label") }}
        <span class="font-bold">{{ t("projection_value", { count: monthlyPerformance.projection }) }}</span>
      </p>
      <div class="flex items-center gap-3">
        <div class="flex-1 bg-gray-200 rounded-full h-3">
          <div class="bg-red-600 h-3 rounded-full transition-all" :style="{ width: progressPercent + '%' }"></div>
        </div>
        <span class="text-base font-bold text-red-600 whitespace-nowrap">{{ progressPercent }}%</span>
      </div>
    </div>
  </Block>
</template>

<script>
import { Block } from "@estaly/ui";
import { useI18n } from "vue-i18n";

export default {
  components: { Block },
  props: {
    title: { type: String, required: true },
    monthlyPerformance: { type: Object, default: null },
  },
  setup() {
    const { t } = useI18n();
    return { t };
  },
  computed: {
    progressPercent() {
      const target = this.monthlyPerformance?.target;
      const current = this.monthlyPerformance?.salesCurrent ?? 0;
      if (!target || target === 0) return 0;
      return Math.min(100, Math.round((current / target) * 100));
    },
  },
};
</script>

<i18n src="./ObjectiveBlock.i18n.json"></i18n>
